import {
  GET_DATA,
  SEARCH_DATA,
  ADD_ITEM,
  EDIT_ITEM,
  OPEN_EDIT,
  OPEN_PREVIEW,
  RESET_DATA,
  LOG_ACTION,
  LOAD_MORE_DATA,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";
import S3 from "react-aws-s3";
import { doc, getDoc, FieldPath, select } from "firebase/firestore";

export const getProductInventory = (currentProduct) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    // console.log(props)
    dataRef = dataRef.where("product", "==", currentProduct);
    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("location", "==", userLocation);
    }

    return dataRef.get();
  };
};

export const getProductInventoryofBranch = (locationID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;

    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");

    dataRef = dataRef.where("location", "==", locationID);

    return dataRef.get();
  };
};

export const getProductSpecificInventory = (currentProduct) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    // console.log(props)
    dataRef = dataRef.where("product", "==", currentProduct);
    dataRef = dataRef.where("location", "==", userLocation);

    return dataRef.get();
  };
};

export const getProductSpecificInventoryWithLocation = (
  currentProduct,
  branch
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();

    var inventoryID = `${branch.key}_${currentProduct.key}`;

    var inventoryLogRef = Firestore.collection("inventory").doc(inventoryID);

    try {
      const snapshot = await inventoryLogRef.get();
      if (snapshot.exists) {
        const jsonData = snapshot.data();
        return jsonData; // This will return the JSON data of the document.
      } else {
        console.log("Document does not exist");
        return null;
      }
    } catch (error) {
      console.error("Error fetching document:", error);
      return null;
    }
  };
};
export const addNewInventory = (newID) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory");
    var dataDoc = dataRef.doc(newID);
    return dataDoc;
  };
};

export const createLog = (data, docID) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("inventory")
      .doc(docID)
      .collection("inventory_log");
    return dataRef.doc().set(data);
  };
};

export const setProductInventory = (
  productID,
  prod_name,
  newcount,
  mode,
  reason
) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var reduxState = store.getState();
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var inventoryID = `${userLocation}_${productID}`;
    var productRef = Firestore.collection("products").doc(productID);
    var inventoryRef = Firestore.collection("inventory").doc(inventoryID);
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log")
      .doc();

    var updateForm = {
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };
    var newQuantity = 0;
    var restock = 0;
    var currentInventorySnap = await inventoryRef.get();
    var currentInventory = null;
    var inventoryform = {
      ...updateForm,
      reason: reason,
    };
    if (currentInventorySnap.exists) {
      currentInventory = currentInventorySnap.data();
      if (currentInventory.restock) {
        restock = currentInventory.restock;
      }
      if (mode == "change") {
        newQuantity = newcount;
      }
      if (mode == "add") {
        newQuantity =
          parseFloat(currentInventory.quantity) + parseFloat(newcount);
      }
      if (mode == "subtract") {
        newQuantity =
          parseFloat(currentInventory.quantity) - parseFloat(newcount);
        // if(newQuantity < 0){
        //   newQuantity = 0
        // }
      }
    } else {
      if (mode == "change") {
        newQuantity = parseFloat(newcount);
      }
      if (mode == "add") {
        newQuantity = parseFloat(newcount);
      }
      inventoryform = {
        ...updateForm,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        location: userLocation,
        location_name: userLocationName,
        product: productID,
        product_name: prod_name,
      };
    }
    inventoryform["restock"] = restock;
    inventoryform["quantity"] = newQuantity;

    var inventoryLogForm = {
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      reason: reason,
      created_by: userID,
      created_name: userName,
      quantity: newQuantity,
      restock: restock,
    };

    var prodForm = {
      ...updateForm,
    };
    prodForm[`${userLocation}_count`] = newQuantity;
    prodForm[`${userLocation}_restock`] = restock;

    console.log(prodForm);
    console.log(inventoryform);
    console.log(inventoryLogForm);

    var productEdit = await productRef.set(prodForm, { merge: true });

    var InventoryEdit = await inventoryRef.set(inventoryform, { merge: true });

    var makelog = await inventoryLogRef.set(inventoryLogForm);

    return newQuantity;
  };
};

export const setProductInventoryWithLocation = (
  productID,
  prod_name,
  newcount,
  mode,
  reason,
  currentLocation,
  currentLocationName
) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var reduxState = store.getState();

    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var inventoryID = `${currentLocation}_${productID}`;
    var productRef = Firestore.collection("products").doc(productID);
    var inventoryRef = Firestore.collection("inventory").doc(inventoryID);
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log")
      .doc();

    var updateForm = {
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };
    var newQuantity = 0;
    var restock = 0;
    var currentInventorySnap = await inventoryRef.get();
    var currentInventory = null;
    var inventoryform = {
      ...updateForm,
      reason: reason,
    };
    if (currentInventorySnap.exists) {
      currentInventory = currentInventorySnap.data();
      if (currentInventory.restock) {
        restock = currentInventory.restock;
      }
      if (mode == "change") {
        newQuantity = newcount;
      }
      if (mode == "add") {
        newQuantity =
          parseFloat(currentInventory.quantity) + parseFloat(newcount);
      }
      if (mode == "subtract") {
        newQuantity =
          parseFloat(currentInventory.quantity) - parseFloat(newcount);
        // if(newQuantity < 0){
        //   newQuantity = 0
        // }
      }
    } else {
      if (mode == "change") {
        newQuantity = parseFloat(newcount);
      }
      if (mode == "add") {
        newQuantity = parseFloat(newcount);
      }
      inventoryform = {
        ...updateForm,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        location: currentLocation,
        location_name: currentLocationName,
        product: productID,
        product_name: prod_name,
      };
    }
    inventoryform["restock"] = restock;
    inventoryform["quantity"] = newQuantity;

    var inventoryLogForm = {
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      reason: reason,
      created_by: userID,
      created_name: userName,
      quantity: newQuantity,
      restock: restock,
    };

    var prodForm = {
      ...updateForm,
    };
    prodForm[`${currentLocation}_count`] = newQuantity;
    prodForm[`${currentLocation}_restock`] = restock;

    console.log(prodForm);
    console.log(inventoryform);
    console.log(inventoryLogForm);

    var productEdit = await productRef.set(prodForm, { merge: true });

    var InventoryEdit = await inventoryRef.set(inventoryform, { merge: true });

    var makelog = await inventoryLogRef.set(inventoryLogForm);

    return newQuantity;
  };
};

export const getProductInventoryLog = (branchID, productID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryID = `${branchID}_${productID}`;
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");

    // inventoryLogRef = inventoryLogRef.limit(50);

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const getProductInventoryLogwithDateRange = (
  inventoryID,
  start_date,
  end_date
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      ">=",
      moment(start_date).startOf("day").format("YYYY-MM-DD HH:mm:ss")
    );
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      "<=",
      moment(end_date).endOf("day").format("YYYY-MM-DD HH:mm:ss")
    );

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const getProductInventoryLogLastestFromDate = (
  inventoryID,
  datePickerValue
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var Firestore = firebase.firestore();

    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log");
    // console.log(props)
    inventoryLogRef = inventoryLogRef.orderBy("created_at", "desc");
    console.log(datePickerValue);
    console.log(datePickerValue[1]);
    let end_date = datePickerValue[1];
    // inventoryLogRef = inventoryLogRef.where('created_at', '>=',  moment(start_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'))
    inventoryLogRef = inventoryLogRef.where(
      "created_at",
      "<=",
      moment(end_date).endOf("day").format("YYYY-MM-DD HH:mm:ss")
    );

    inventoryLogRef = inventoryLogRef.limit(1);

    var documentSnapshots = await inventoryLogRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (logItem) => {
        var newLog = {
          key: logItem.id,
          id: logItem.id,
          ...logItem.data(),
        };
        dataArray.push(newLog);
      })
    );
    return dataArray;
  };
};

export const updateOrSaveInventoryWithAuditField = (
  currentProduct,
  branch,
  excludeValue
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();

    var inventoryID = `${branch.key}_${currentProduct.key}`;
    var inventoryLogRef = Firestore.collection("inventory").doc(inventoryID);

    try {
      await inventoryLogRef.set(
        {
          excludeFromAudit: excludeValue, // This is the new field you'd like to add or update
        },
        { merge: true }
      ); // This ensures that the new data is merged with any existing data in the document

      console.log(
        "Document successfully updated/created with excludeFromAudit field."
      );
      return true; // Successfully updated/created
    } catch (error) {
      console.error("Error updating/creating document:", error);
      return false; // Failed to update/create
    }
  };
};

const normalizeTransferQuantity = (value) => {
  var parsed = parseFloat(value);
  if (Number.isNaN(parsed)) {
    return 0;
  }
  return parsed;
};

const buildTransferReasonText = (
  sourceLocationName,
  destinationLocationName,
  reason,
  note
) => {
  var reasonParts = [`${sourceLocationName} -> ${destinationLocationName}`];

  if (reason) {
    reasonParts.push(reason);
  }

  if (note) {
    reasonParts.push(note);
  }

  return `inventory transfer: ${reasonParts.join(" | ")}`;
};

export const transferInventoryBetweenLocations = ({
  products,
  sourceLocation,
  destinationLocation,
  reason,
  note,
}) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var user = reduxState.auth.user;

    if (user.role !== "admin") {
      throw new Error("Only admins can transfer inventory.");
    }

    if (!sourceLocation?.id || !destinationLocation?.id) {
      throw new Error("Both source and destination branches are required.");
    }

    if (sourceLocation.id === destinationLocation.id) {
      throw new Error("Source and destination branches must be different.");
    }

    var normalizedProducts = (products || [])
      .map((item) => {
        var quantity = normalizeTransferQuantity(
          item.transfer_quantity ?? item.quantity
        );
        return {
          id: item.id || item.product,
          name: item.name || item.product_name,
          sku: item.sku || "",
          unit: item.unit || "",
          sourceStock: normalizeTransferQuantity(item.sourceStock),
          destinationStock: normalizeTransferQuantity(item.destinationStock),
          quantity: quantity,
        };
      })
      .filter((item) => item.id && item.quantity > 0);

    if (normalizedProducts.length === 0) {
      throw new Error("Add at least one product with a transfer quantity.");
    }

    var Firestore = firebase.firestore();
    var transferRef = Firestore.collection("inventory_transfers").doc();
    var createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
    var transferReason = buildTransferReasonText(
      sourceLocation.name,
      destinationLocation.name,
      reason,
      note
    );

    var transferSummary = [];
    var fieldValue = firebase.firestore.FieldValue;

    for (const item of normalizedProducts) {
      var currentSourceQuantity = normalizeTransferQuantity(item.sourceStock);
      var currentDestinationQuantity = normalizeTransferQuantity(
        item.destinationStock
      );
      var productName = item.name || "";
      var productSku = item.sku || "";
      var productUnit = item.unit || "";

      if (currentSourceQuantity < item.quantity) {
        throw new Error(
          `${item.name || "This product"} only has ${currentSourceQuantity} ${
            productUnit || "units"
          } available in ${sourceLocation.name}.`
        );
      }

      var nextSourceQuantity = currentSourceQuantity - item.quantity;
      var nextDestinationQuantity = currentDestinationQuantity + item.quantity;
      var productRef = Firestore.collection("products").doc(item.id);
      var sourceInventoryRef = Firestore
        .collection("inventory")
        .doc(`${sourceLocation.id}_${item.id}`);
      var destinationInventoryRef = Firestore
        .collection("inventory")
        .doc(`${destinationLocation.id}_${item.id}`);
      var sourceLogRef = sourceInventoryRef.collection("inventory_log").doc();
      var destinationLogRef = destinationInventoryRef
        .collection("inventory_log")
        .doc();
      var batch = Firestore.batch();

      var inventoryMeta = {
        updated_at: createdAt,
        updated_by: user.id,
        updated_name: user.name,
        reason: transferReason,
      };

      batch.set(
        sourceInventoryRef,
        {
          ...inventoryMeta,
          created_at: createdAt,
          location: sourceLocation.id,
          location_name: sourceLocation.name,
          product: item.id,
          product_name: productName,
          quantity: fieldValue.increment(item.quantity * -1),
        },
        { merge: true }
      );

      batch.set(
        destinationInventoryRef,
        {
          ...inventoryMeta,
          created_at: createdAt,
          location: destinationLocation.id,
          location_name: destinationLocation.name,
          product: item.id,
          product_name: productName,
          quantity: fieldValue.increment(item.quantity),
        },
        { merge: true }
      );

      batch.set(
        productRef,
        {
          updated_at: createdAt,
          updated_by: user.id,
          updated_name: user.name,
          [`${sourceLocation.id}_count`]: fieldValue.increment(item.quantity * -1),
          [`${destinationLocation.id}_count`]: fieldValue.increment(item.quantity),
        },
        { merge: true }
      );

      var transferLogBase = {
        created_at: createdAt,
        created_by: user.id,
        created_name: user.name,
        is_transfer: true,
        transfer_id: transferRef.id,
        transfer_group_id: transferRef.id,
        transfer_quantity: item.quantity,
        product: item.id,
        product_name: productName,
        source_location: sourceLocation.id,
        source_location_name: sourceLocation.name,
        destination_location: destinationLocation.id,
        destination_location_name: destinationLocation.name,
        note: note || "",
        transfer_reason: reason || "",
      };

      batch.set(sourceLogRef, {
        ...transferLogBase,
        reason: `transfer out to ${destinationLocation.name}`,
        quantity: nextSourceQuantity,
        transfer_direction: "out",
        change_quantity: item.quantity * -1,
      });

      batch.set(destinationLogRef, {
        ...transferLogBase,
        reason: `transfer in from ${sourceLocation.name}`,
        quantity: nextDestinationQuantity,
        transfer_direction: "in",
        change_quantity: item.quantity,
      });

      await batch.commit();

      transferSummary.push({
        id: item.id,
        product: item.id,
        product_name: productName,
        sku: productSku,
        unit: productUnit,
        quantity: item.quantity,
        source_before: currentSourceQuantity,
        source_after: nextSourceQuantity,
        destination_before: currentDestinationQuantity,
        destination_after: nextDestinationQuantity,
      });
    }

    await transferRef.set({
      created_at: createdAt,
      created_by: user.id,
      created_name: user.name,
      created_email: user.email || "",
      source_location: sourceLocation.id,
      source_location_name: sourceLocation.name,
      destination_location: destinationLocation.id,
      destination_location_name: destinationLocation.name,
      reason: reason || "",
      note: note || "",
      product_count: transferSummary.length,
      total_quantity: transferSummary.reduce(
        (sum, item) => sum + normalizeTransferQuantity(item.quantity),
        0
      ),
      products: transferSummary,
    });

    return {
      id: transferRef.id,
      source_location: sourceLocation.id,
      source_location_name: sourceLocation.name,
      destination_location: destinationLocation.id,
      destination_location_name: destinationLocation.name,
      reason: reason || "",
      note: note || "",
      created_at: createdAt,
      products: transferSummary,
    };
  };
};

export const getInventoryTransferHistory = ({
  limit = 100,
  sourceLocationId,
  destinationLocationId,
  searchText,
  productIds,
} = {}) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var user = reduxState.auth.user;

    if (user.role !== "admin") {
      throw new Error("Only admins can view inventory transfer history.");
    }

    var Firestore = firebase.firestore();
    var transfersRef = Firestore
      .collection("inventory_transfers")
      .orderBy("created_at", "desc")
      .limit(limit);

    var snapshot = await transfersRef.get();
    var normalizedSearch = (searchText || "").toLowerCase().trim();
    var normalizedProductIds = Array.isArray(productIds)
      ? productIds.filter(Boolean)
      : [];

    var dataArray = snapshot.docs.map((item) => ({
      key: item.id,
      id: item.id,
      ...item.data(),
    }));

    if (sourceLocationId) {
      dataArray = dataArray.filter(
        (item) => item.source_location === sourceLocationId
      );
    }

    if (destinationLocationId) {
      dataArray = dataArray.filter(
        (item) => item.destination_location === destinationLocationId
      );
    }

    if (normalizedProductIds.length > 0) {
      dataArray = dataArray.filter((item) =>
        (item.products || []).some((product) =>
          normalizedProductIds.includes(product.product || product.id)
        )
      );
    }

    if (normalizedSearch) {
      dataArray = dataArray.filter((item) => {
        var productSearchValues = [];
        (item.products || []).forEach((product) => {
          productSearchValues.push(product.product_name);
          productSearchValues.push(product.sku);
        });

        var haystack = [
          item.id,
          item.created_name,
          item.source_location_name,
          item.destination_location_name,
          item.reason,
          item.note,
          ...productSearchValues,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return haystack.includes(normalizedSearch);
      });
    }

    return dataArray;
  };
};
